import { isFilled, type ImageField } from '@prismicio/client'
import { PrismicNextImage } from '@prismicio/next'
import { cn } from '@/utils/twMerge'

/** Default display size for mega-menu / mobile side-nav list-row icons. */
export const NAVBAR_DROPDOWN_ICON_SIZE = 24

/** Compact size for dense title-only rows (e.g. Framework Resources). */
export const NAVBAR_DROPDOWN_ICON_SIZE_SM = 20

type NavbarDropdownIconSize = typeof NAVBAR_DROPDOWN_ICON_SIZE | typeof NAVBAR_DROPDOWN_ICON_SIZE_SM

type NavbarDropdownIconProps = {
  field: ImageField | null | undefined
  className?: string
  /** Pixel size; defaults to 24. Use 20 for dense title-only lists. */
  size?: NavbarDropdownIconSize
}

const sizeClassName: Record<NavbarDropdownIconSize, string> = {
  [NAVBAR_DROPDOWN_ICON_SIZE]: 'h-6 w-6',
  [NAVBAR_DROPDOWN_ICON_SIZE_SM]: 'h-5 w-5',
}

/**
 * Shared list-row icon for navbar dropdowns.
 * Card imagery (solutions logos, gap assessment) should not use this.
 */
const NavbarDropdownIcon = ({ field, className, size = NAVBAR_DROPDOWN_ICON_SIZE }: NavbarDropdownIconProps) => {
  if (!isFilled.image(field)) return null

  return (
    <PrismicNextImage
      field={field}
      width={size}
      height={size}
      loading="lazy"
      fallbackAlt=""
      className={cn('navbar-dropdown-icon shrink-0 object-contain', sizeClassName[size], className)}
    />
  )
}

export default NavbarDropdownIcon
